// src/pages/public/CmsPage.jsx
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { cmsPublicApi as cmsApi } from '../../api/services'
import { PageSpinner } from '../../components/common/ui'

export default function CmsPage() {
  const { slug } = useParams()
  const { data, isLoading } = useQuery({ queryKey: ['cms-page', slug], queryFn: () => cmsApi.page(slug) })

  if (isLoading) return <PageSpinner />
  const page = data?.data?.data || data?.data
  if (!page) return <div className="py-24 text-center text-muted">Page not found.</div>

  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-display font-bold text-gray-900 mb-8">{page.title}</h1>
      <div className="prose prose-sm max-w-none text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: page.body }} />
    </div>
  )
}
